/* eslint-disable */

//hamburger menu
export const HamburgerMenu = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  );
};

//eye
export const Eye = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        stroke-linejoin="round"
        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
      />
      <path strokeLinecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );
};

//eye-slash
export const EyeSlash = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
      />
    </svg>
  );
};

//shield check
export const ShieldCheck = ({ className, ...props }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
      />
    </svg>
  );
};

//calendar days
export const CalendarDays = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
      />
    </svg>
  );
};

export const ArrowUndo = ({ className, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512">
      <path d="M245.09 327.74v-37.32c57.07 0 84.51 13.47 108.58 38.68 5.4 5.65 15 1.32 14.29-6.43-5.45-61.45-34.14-117.09-122.87-117.09v-37.32a8.32 8.32 0 00-14.05-6L146.58 242a8.2 8.2 0 000 11.94L231 333.71a8.32 8.32 0 0014.09-5.97z" />
      <path
        d="M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={32}
      />
    </svg>
  );
};

export const ChevronRight = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
    </svg>
  );
};

export const DocumentText = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
      />
    </svg>
  );
};

export const CloseIcon = ({ className, ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      className={className}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
};

export const Envelope = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
      />
    </svg>
  );
};

export const UserIcon = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

//notifications
export const Notifications = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
      />
    </svg>
  );
};

//plus
export const Plus = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      className={className}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>
  );
};

//shopping bag
export const ShoppingBag = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
      />
    </svg>
  );
};

//home
export const Home = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
      />
    </svg>
  );
};

//pencil

export const PencilIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
      />
    </svg>
  );
};

export const CheckCircle = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
};

export const EmptyCircle = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M25 25L25 25 25 25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
};

// Download Icon
export const DownloadIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3v12m0 0l3.5-3.5M12 15l-3.5-3.5M21 21H3"
      />
    </svg>
  );
};

export const LogoutIcon = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <line className="st1" x1="7.6" x2="22" y1="12" y2="12" />
        </g>
        <g>
          <path
            className="st1"
            d="M11.9,0.8H4.5C3.1,0.8,2,1.9,2,3.2v17.5c0,1.4,1.1,2.5,2.5,2.5h7.4"
            fill="none"
          />
        </g>
        <polyline className="st1" points="18.2,8.2 22,12 18.2,15.8  " />
      </g>
    </svg>
  );
};

export const Stepper25perc = ({ className, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" className={className}>
      <circle cx="50" cy="50" r="40" fill="none" stroke="#ddd" strokeWidth={15} />
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        className="stroke-stepper-icon"
        strokeWidth="15"
        strokeDasharray="55.4, 230.6"
        transform="rotate(-90 50 50)"
        strokeLinecap="round"
      ></circle>
    </svg>
  );
};

export const Stepper50perc = ({ className, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" className={className}>
      <circle cx="50" cy="50" r="40" fill="none" stroke="#ddd" strokeWidth={15} />
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        className="stroke-stepper-icon"
        strokeWidth="15"
        strokeDasharray="122.4, 230.6"
        transform="rotate(-90 50 50)"
        strokeLinecap="round"
      ></circle>
    </svg>
  );
};

export const Stepper75perc = ({ className, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" className={className}>
      <circle cx="50" cy="50" r="40" fill="none" stroke="#ddd" strokeWidth={15} />
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        className="stroke-stepper-icon"
        strokeWidth="15"
        strokeDasharray="185.4, 230.6"
        transform="rotate(-90 50 50)"
        strokeLinecap="round"
      ></circle>
    </svg>
  );
};

export const ChevronCompactUp = ({ className, ...props }) => {
  return (
    <svg fill="currentColor" viewBox="0 0 16 16" className={className} {...props}>
      <path
        fillRule="evenodd"
        d="M7.776 5.553a.5.5 0 01.448 0l6 3a.5.5 0 11-.448.894L8 6.56 2.224 9.447a.5.5 0 11-.448-.894l6-3z"
      />
    </svg>
  );
};

export const ChevronCompactDown = ({ className, ...props }) => {
  return (
    <svg fill="currentColor" viewBox="0 0 16 16" className={className} {...props}>
      <path
        fillRule="evenodd"
        d="M1.553 6.776a.5.5 0 01.67-.223L8 9.44l5.776-2.888a.5.5 0 11.448.894l-6 3a.5.5 0 01-.448 0l-6-3a.5.5 0 01-.223-.67z"
      />
    </svg>
  );
};

export const InfoCircle = ({ className, ...props }) => {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 1024 1024" {...props}>
      <path
        className={className}
        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
      ></path>
      <path
        className={className}
        d="M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
      ></path>
    </svg>
  );
};

export const Warning = ({ className, ...props }) => {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"></path>
    </svg>
  );
};

// icon:umbrella-outline | Ionicons https://ionicons.com/ | Ionic Framework
export const Insurance = ({ className, ...props }) => {
  return (
    <svg className={`${className} insurance`} viewBox="0 0 512 512" {...props}>
      <path
        d="M256 272v160a32 32 0 01-32 32h0a32 32 0 01-32-32M464 272c0-114.88-93.12-208-208-208S48 157.12 48 272h0a67.88 67.88 0 0196 0h0a78.28 78.28 0 01102.31-7.27L256 272l9.69-7.27A78.28 78.28 0 01368 272h0a67.88 67.88 0 0196 0zM256 64V48"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// icon:file-search | Ant Design Icons https://ant.design/components/icon/ | Ant Design
export const FileSearch = ({ className, ...props }) => {
  return (
    <svg className={className} viewBox="0 0 1024 1024" {...props}>
      <path
        className={className}
        d="M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 000-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
      />
    </svg>
  );
};

// icon:receipt-outline | Ionicons https://ionicons.com/ | Ionic Framework
export const ReceiptOutline = ({ className, ...props }) => {
  return (
    <svg className={`${className} receipt`} viewBox="0 0 512 512" fill="currentColor" {...props}>
      <path
        d="M160 336V48l32 16 32-16 31.94 16 32.37-16L320 64l31.79-16 31.93 16L416 48l32.01 16L480 48v224"
        fill="none"
        strokeLinejoin="round"
        strokeWidth={32}
      />
      <path
        d="M480 272v112a80 80 0 01-80 80h0a80 80 0 01-80-80v-48H48a15.86 15.86 0 00-16 16c0 64 6.74 112 80 112h288"
        fill="none"
        strokeLinejoin="round"
        strokeWidth={32}
      />
      <path
        d="M224 144h192M288 224h128"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
      />
    </svg>
  );
};

// icon:help-buoy-outline | Ionicons https://ionicons.com/ | Ionic Framework
export const BuoyOutline = ({ className, ...props }) => {
  return (
    <svg
      className={`${className} buoy`}
      fill="none"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M464 256 A208 208 0 0 1 256 464 A208 208 0 0 1 48 256 A208 208 0 0 1 464 256 z" />
      <path d="M336 256 A80 80 0 0 1 256 336 A80 80 0 0 1 176 256 A80 80 0 0 1 336 256 z" />
      <path d="M208 54l8 132M296 186l8-132M208 458l8-132M296 326l8 132M458 208l-132 8M326 296l132 8M54 208l132 8M186 296l-132 8" />
    </svg>
  );
};

// icon:270-cancel-circle | Icomoon https://icomoon.io/ | Keyamoon
export const CancelCircle = ({ className, ...props }) => {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 16 16" {...props}>
      <path d="M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z" />
      <path d="M10.5 4L8 6.5 5.5 4 4 5.5 6.5 8 4 10.5 5.5 12 8 9.5l2.5 2.5 1.5-1.5L9.5 8 12 5.5z" />
    </svg>
  );
};

// icon:qr-code-outline | Ionicons https://ionicons.com/ | Ionic Framework
export const QrCodeIcon = ({ className, ...props }) => {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 512 512" {...props}>
      <path d="M344 336 H408 A8 8 0 0 1 416 344 V408 A8 8 0 0 1 408 416 H344 A8 8 0 0 1 336 408 V344 A8 8 0 0 1 344 336 z" />
      <path d="M280 272 H328 A8 8 0 0 1 336 280 V328 A8 8 0 0 1 328 336 H280 A8 8 0 0 1 272 328 V280 A8 8 0 0 1 280 272 z" />
      <path d="M424 416 H472 A8 8 0 0 1 480 424 V472 A8 8 0 0 1 472 480 H424 A8 8 0 0 1 416 472 V424 A8 8 0 0 1 424 416 z" />
      <path d="M440 272 H472 A8 8 0 0 1 480 280 V312 A8 8 0 0 1 472 320 H440 A8 8 0 0 1 432 312 V280 A8 8 0 0 1 440 272 z" />
      <path d="M280 432 H312 A8 8 0 0 1 320 440 V472 A8 8 0 0 1 312 480 H280 A8 8 0 0 1 272 472 V440 A8 8 0 0 1 280 432 z" />
      <path d="M344 96 H408 A8 8 0 0 1 416 104 V168 A8 8 0 0 1 408 176 H344 A8 8 0 0 1 336 168 V104 A8 8 0 0 1 344 96 z" />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M304 48 H448 A16 16 0 0 1 464 64 V208 A16 16 0 0 1 448 224 H304 A16 16 0 0 1 288 208 V64 A16 16 0 0 1 304 48 z"
      />
      <path d="M104 96 H168 A8 8 0 0 1 176 104 V168 A8 8 0 0 1 168 176 H104 A8 8 0 0 1 96 168 V104 A8 8 0 0 1 104 96 z" />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M64 48 H208 A16 16 0 0 1 224 64 V208 A16 16 0 0 1 208 224 H64 A16 16 0 0 1 48 208 V64 A16 16 0 0 1 64 48 z"
      />
      <path d="M104 336 H168 A8 8 0 0 1 176 344 V408 A8 8 0 0 1 168 416 H104 A8 8 0 0 1 96 408 V344 A8 8 0 0 1 104 336 z" />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M64 288 H208 A16 16 0 0 1 224 304 V448 A16 16 0 0 1 208 464 H64 A16 16 0 0 1 48 448 V304 A16 16 0 0 1 64 288 z"
      />
    </svg>
  );
};

// icon:bag-x | Bootstrap https://icons.getbootstrap.com/ | Bootstrap
export const BagXIcon = ({ className, ...props }) => {
  return (
    <svg className={className} viewBox="0 0 16 16" {...props}>
      <path
        strokeWidth={0.25}
        d="M6.146 8.146a.5.5 0 01.708 0L8 9.293l1.146-1.147a.5.5 0 11.708.708L8.707 10l1.147 1.146a.5.5 0 01-.708.708L8 10.707l-1.146 1.147a.5.5 0 01-.708-.708L7.293 10 6.146 8.854a.5.5 0 010-.708z"
      />
      <path
        strokeWidth={0.25}
        d="M8 1a2.5 2.5 0 012.5 2.5V4h-5v-.5A2.5 2.5 0 018 1zm3.5 3v-.5a3.5 3.5 0 10-7 0V4H1v10a2 2 0 002 2h10a2 2 0 002-2V4h-3.5zM2 5h12v9a1 1 0 01-1 1H3a1 1 0 01-1-1V5z"
      />
    </svg>
  );
};

// icon:basic_headset | Linea Iconset https://linea.io/ | Benjamin Sigidi
export const HeadsetIcon = ({ className, ...props }) => {
  return (
    <svg className={`${className} headset`} fill="currentColor" viewBox="0 0 64 64" {...props}>
      <path
        className={className}
        fill="none !important"
        strokeMiterlimit={10}
        d="M11 48C5.477 48 1 43.523 1 38s4.477-10 10-10h2v20h-2zM53 28c5.523 0 10 4.477 10 10s-4.477 10-10 10h-2V28h2zM13 31v-9S13 6 32 6s19 16 19 16v6M51 48v5l-15 6h-8v-4h8v3"
      />
    </svg>
  );
};

// icon:bx-building-house | Boxicons https://boxicons.com/ | Atisa
export const BuildingHouseIcon = ({ className, ...props }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" {...props}>
      <path
        className={className}
        d="M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 003 16v5a1 1 0 001 1h16a1 1 0 001-1V4c0-1.103-.897-2-2-2zm-8 18H5v-5.586l3-3 3 3V20zm8 0h-6v-4a.999.999 0 00.707-1.707L9 9.586V4h10v16z"
      />
      <path
        className={className}
        d="M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 1h2v2H7z"
      />
    </svg>
  );
};

// icon:telephone | Bootstrap https://icons.getbootstrap.com/ | Bootstrap
export const TelephoneIcon = ({ className, ...props }) => {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 16 16" {...props}>
      <path d="M3.654 1.328a.678.678 0 00-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 004.168 6.608 17.569 17.569 0 006.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 00-.063-1.015l-2.307-1.794a.678.678 0 00-.58-.122l-2.19.547a1.745 1.745 0 01-1.657-.459L5.482 8.062a1.745 1.745 0 01-.46-1.657l.548-2.19a.678.678 0 00-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 012.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 00.178.643l2.457 2.457a.678.678 0 00.644.178l2.189-.547a1.745 1.745 0 011.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 01-7.01-4.42 18.634 18.634 0 01-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
    </svg>
  );
};

// icon:phone | Feathericons https://feathericons.com/ | Cole Bemis
export const IconPhone = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
    </svg>
  );
};

// icon:bx-at | Boxicons https://boxicons.com/ | Atisa
export const AtIcon = ({ className, ...props }) => {
  return (
    <svg className={`${className} at`} fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c1.466 0 2.961-.371 4.442-1.104l-.885-1.793C14.353 19.698 13.156 20 12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8v1c0 .692-.313 2-1.5 2-1.396 0-1.494-1.819-1.5-2V8h-2v.025A4.954 4.954 0 0012 7c-2.757 0-5 2.243-5 5s2.243 5 5 5c1.45 0 2.748-.631 3.662-1.621.524.89 1.408 1.621 2.838 1.621 2.273 0 3.5-2.061 3.5-4v-1c0-5.514-4.486-10-10-10zm0 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
        strokeWidth={0}
      />
    </svg>
  );
};

// addAXA Figma
export const TooltipQuestionIcon = ({ className, ...props }) => {
  return (
    <svg className={className} viewBox="0 0 21 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.91992 7.14481C9.09612 6.64394 9.4439 6.22158 9.90166 5.95255C10.3594 5.68352 10.8976 5.58518 11.4209 5.67494C11.9443 5.76471 12.4189 6.03678 12.7609 6.44298C13.1028 6.84918 13.29 7.36329 13.2892 7.89426C13.2892 9.39314 11.0408 10.1426 11.0408 10.1426M11.0698 13.1426H11.0798M8.81992 17.8426L10.2799 19.7892C10.497 20.0787 10.6056 20.2235 10.7387 20.2752C10.8553 20.3206 10.9846 20.3206 11.1012 20.2752C11.2342 20.2235 11.3428 20.0787 11.5599 19.7892L13.0199 17.8426C13.3131 17.4517 13.4596 17.2563 13.6384 17.1071C13.8768 16.9081 14.1582 16.7674 14.4604 16.6961C14.6871 16.6426 14.9313 16.6426 15.4199 16.6426C16.8177 16.6426 17.5167 16.6426 18.068 16.4142C18.8031 16.1097 19.3871 15.5257 19.6916 14.7906C19.9199 14.2393 19.9199 13.5404 19.9199 12.1426V6.44258C19.9199 4.76242 19.9199 3.92234 19.5929 3.28061C19.3053 2.71612 18.8464 2.25718 18.2819 1.96956C17.6402 1.64258 16.8001 1.64258 15.1199 1.64258H6.71992C5.03976 1.64258 4.19969 1.64258 3.55795 1.96956C2.99346 2.25718 2.53452 2.71612 2.2469 3.28061C1.91992 3.92234 1.91992 4.76242 1.91992 6.44258V12.1426C1.91992 13.5404 1.91992 14.2393 2.14828 14.7906C2.45277 15.5257 3.03679 16.1097 3.77187 16.4142C4.32318 16.6426 5.0221 16.6426 6.41992 16.6426C6.9085 16.6426 7.15279 16.6426 7.37943 16.6961C7.68161 16.7674 7.96304 16.9081 8.20142 17.1071C8.3802 17.2563 8.52677 17.4517 8.81992 17.8426Z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// icon:people-outline | Ionicons https://ionicons.com/ | Ionic Framework
export const PeopleIcon = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M402 168c-2.93 40.67-33.1 72-66 72s-63.12-31.32-66-72c-3-42.31 26.37-72 66-72s69 30.46 66 72z"
      />
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={32}
        d="M336 304c-65.17 0-127.84 32.37-143.54 95.41-2.08 8.34 3.15 16.59 11.72 16.59h263.65c8.57 0 13.77-8.25 11.72-16.59C463.85 335.36 401.18 304 336 304z"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M200 185.94c-2.34 32.48-26.72 58.06-53 58.06s-50.7-25.57-53-58.06C91.61 152.15 115.34 128 147 128s55.39 24.77 53 57.94z"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={32}
        d="M206 306c-18.05-8.27-37.93-11.45-59-11.45-52 0-102.1 25.85-114.65 76.2-1.65 6.66 2.53 13.25 9.37 13.25H154"
      />
    </svg>
  );
}

// icon:power-outline | Ionicons https://ionicons.com/ | Ionic Framework
export const PowerOutline = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        className={className}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={32}
        d="M378 108a191.41 191.41 0 0170 148c0 106-86 192-192 192S64 362 64 256a192 192 0 0169-148M256 64v192"
      />
    </svg>
  );
}

export const ClosedEye = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
      />
    </svg>
  );
}

export const OpenedEye = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
}

// icon:search-outline | Ionicons https://ionicons.com/ | Ionic Framework
export const SearchOutline = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={32}
        d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={32}
        d="M338.29 338.29L448 448"
      />
    </svg>
  );
}
